<template>
  <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
    <div
        v-for="index in 7"
        :key="index"
        class="relative overflow-hidden rounded-xl"
    >
      <div class="w-full h-20 animate-pulse"></div>
    </div>
  </div>
</template>
